import { Injectable } from '@angular/core';
import { BasePagedCrudService } from "../../shared/crud/base-crud.service";
import { CreateSestavenyVykazHlavickaDto, EditSestavenyVykazHlavickaDto, SestavenyVykazHlavickaDto } from "./models/SestavenyVykazHlavickaDtos";
import { HttpClient } from "@angular/common/http";
import { CrudSettings, QueryParams } from "../../shared/crud/abstractions/base-crud";
import { EnvironmentService } from '../../core/environment/environment.service';
import {DialogService} from "../../shared/dialog/dialog.service";
import {MatSnackBar} from "@angular/material/snack-bar";

Injectable({
  providedIn: 'root'
})
export class SestavenyVykazHlavickaCrudSettings implements CrudSettings<number, SestavenyVykazHlavickaDto> {
  baseUrl = '';
  postUrl = undefined;
  queryParam = undefined;
  createSuffix = undefined;
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editSuffix = undefined;
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  getListSuffix = 'UcetniJednotka';
  getSuffix = undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  idGetter = (entity: SestavenyVykazHlavickaDto) => entity.id;

  mapper(id: number): QueryParams {
    const dict = new Map<string, number>();
    dict.set('id', id);
    return {params: dict}
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.pubgw + '/api/SestavenyVykaz/HlavickaVykazu';
  }
}

@Injectable
({
  providedIn: null
})
export class SestavenyVykazHlavickaDataService
  extends BasePagedCrudService<number, SestavenyVykazHlavickaDto, CreateSestavenyVykazHlavickaDto, EditSestavenyVykazHlavickaDto>{

  constructor(private _http: HttpClient, public environmentService: EnvironmentService, override dialogService: DialogService) {
    super(_http, new SestavenyVykazHlavickaCrudSettings(environmentService), dialogService);
  }
}
